import { CustomCollapseCard, Text } from '@src/components';
import { moneyFormat } from '@src/utils/utils';
import dayjs from '@src/utils/day';
import { defaultDateFormat } from '@src/utils/keys';
import { monthsList } from '@src/store/enums';
import { useSelector } from 'react-redux';
import '@src/styles/balanceUpload/orderSummaryInformation.scss';

const OrderSummaryInformation = () => {
  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);

  const invoiceMonthText = monthsList
    .filter((month) => month.value === currentLoadBalance?.invoiceMonth)
    .reduce((acc, month) => month.text, '');

  return (
    <>
      <CustomCollapseCard
        cardTitle={<Text t="orderSummaryTitle" />}
        cardTitleAlign="center"
        className="balance-upload-order-summary-information"
      >
        <div className="balance-upload-summary-container">
          <div className="order-summary-col-1">
            <div className="title">
              <b><Text t="orderType" />:</b>{' '}
              <span>{currentLoadBalance?.periodType === 0 ? <Text t="daily" /> : <Text t="monthly" />}</span>
            </div>
            <div className="title">
              <b>
                <Text t="invoiceMonth2" />
              </b>{' '}
              <span>{invoiceMonthText}</span>
            </div>
          </div>
          <div className="order-summary-col-2">
            <div className="title">
              <b>
                <Text t="dateWhenBalanceWillBeActive2" />
              </b>
              <span>{dayjs(currentLoadBalance?.activationDate).format(defaultDateFormat)}</span>
            </div>
            <div className="title e-invoice-information">
              <b>
                <Text t="eInvoiceAdditionalInformation2" />
              </b>{' '}
              <span>{currentLoadBalance?.eInvoiceInformation}</span>
            </div>
            <div className="title">
              <b>
                <Text t="invoiceAddress" />
              </b>{' '}
              <span>{currentLoadBalance?.invoiceAddress}</span>
            </div>
          </div>
          <div className="order-summary-col-3">
            <div className="custom-info-box">
              <div className="title">
                <b><Text t="numberOfCards3"/>:</b>
              </div>
              <span>{currentLoadBalance?.totalCount}</span>
            </div>
            <div className="custom-info-box">
              <div className="title">
                <b><Text t="totalBalanceToBeLoaded" />:</b>
              </div>
              <span>{moneyFormat(currentLoadBalance?.totalPrice, true)}</span>
            </div>
            <div className="custom-info-box">
              <div className="title">
                <b><Text t="totalAmountToBePaid" />:</b>
              </div>
              <span>{moneyFormat(currentLoadBalance?.totalPaymentAmount, true)}</span>
            </div>
          </div>
        </div>
      </CustomCollapseCard>
    </>
  );
};

export default OrderSummaryInformation;
